import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import MenuTabs from '../../../core/MenuTabs';
import Modal from '../../../core/Modal';
import Input from '../../../core/Input';
import { AccordionActions } from '../../../core/AccordionActions';
import TitleGivens from '../../../core/TitleGivens';
import Label from '../../../core/Label';
import Buttons from '../../../core/Buttons';
import DropdownInput from '../../../core/DropdownInput';
import { Cell } from '../../../core/Table';
import TwoLevelBreadcrumb from '../../../core/TwoLevelBreadcrumb';

const StyledMenuTabs = styled(MenuTabs)`
  margin: 0 auto;
  max-width: ${rem('1240px')};
  position: relative;
`;

const StyledMain = styled.div`
  background-color: white;

  .payrrol-otherWrapper {
    max-width: ${rem('500px')};
    width: 100%;
  }

  .payrrol-other {
    width: 100%;
  }
`;

const StyledWrapper = styled.div`
  margin: 0 auto;
  padding: ${rem('10px')};
  max-width: ${rem('1280px')};
  ${mediaqueries.greaterThan('tablet')`
    ${props =>
      !props.formPayrroll &&
      css`
        display: flex;
      `}    
    padding-top: 64px;
    flex-wrap: wrap;
  `};
`;

const StyledLatestPayrolls = styled.div`
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    margin-top:${rem('-34px')};
  `};
`;

const StyledBoxContainer = styled.div`
  padding: ${rem('10px')} ${rem('20px')};
  ${mediaqueries.greaterThan('tablet')`
    display: flex;
    width: 50%;
    `};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0.625rem 45px 0.625rem 0.625rem;
    max-width: ${rem('500px')};
  `};
`;

const StyledModal = styled(Modal)`
  text-align: center;
`;

const StyledInput = styled(Input)`
  max-width: ${rem('260px')};
  margin: ${rem('20px')} auto ${rem('30px')} auto;
  display: block;
`;

const StyledAccordionActions = styled(AccordionActions)`
  text-align: left;
  max-width: ${rem('480px')};
  margin: 0 auto;
`;

const StyledAccordionActionsTableInfo = styled.table`
  font-size: ${rem('14px')};
  margin: ${rem('3px')} ${rem('-10px')} 0;
  td,
  th {
    padding: ${rem('2px')} ${rem('10px')};
    font-weight: 500;
  }
  th {
    font-family: ${props => props.theme.fonts.medium};
  }
`;

const StyledTitleGivens = styled(TitleGivens)`
  ${mediaqueries.greaterThan('desktop')`
    background: transparent;
  `};
`;

const StyledLatestPayrollsList = styled.ul`
  border-color: ${props => props.theme.colors.grayLight};
  border-style: solid;
  border-width: ${rem('1px')};
  display: block;
  margin: 0;
  padding: 0;
  ${mediaqueries.greaterThan('desktop')`
    border-top: 0 none;
  `};
`;

const StyledLatestPayrollsItem = styled.li`
  align-items: stretch;
  background-color: ${props => props.theme.colors.grayMoreLight};
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  display: flex;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${props => props.theme.fontSize.small};
  line-height: 1;
  margin: 0;
  padding: 0;
  cursor: pointer;
  transition: background 0.3s ease;
  &:hover {
    background-color: ${props => props.theme.colors.grayLightest};
    svg {
      fill: ${props => props.theme.colors.primary};
    }
  }
  &:before {
    content: none;
  }
  &:last-child {
    border-bottom-color: transparent;
  }
`;

const StyledLatestPayrollsText = styled.span`
  display: block;
  padding: ${rem('17px')} 0 ${rem('16px')} ${rem('20px')};
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('13px')} 0 ${rem('10px')} ${rem('20px')};
  `};
`;

const StyledLatestPayrollsButton = styled.a`
  padding: ${rem('14px')} ${rem('20px')} ${rem('14px')} ${rem('10px')};
  > svg {
    height: ${rem('18px')};
    margin-right: 0;
    vertical-align: middle;
    width: ${rem('18px')};
  }
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('10px')} ${rem('13px')} ${rem('10px')} ${rem('13px')};
    > svg{
      height: ${rem('20px')};
      width: ${rem('20px')};
    }  
  `};
`;

const StyledTitle = styled.h2`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  margin-bottom: ${rem('20px')};
`;

const StyledLabel = styled(Label)`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  margin: 0 0 ${rem('5px')} 0;
  ${mediaqueries.greaterThan('tablet')`
    margin: 0 ${rem('10px')} 0 0;
  `};
`;

const StyledDropdownInput = styled(DropdownInput)`
  width: 100%;
  button,
  ul {
    border-color: transparent;
  }
  button {
    align-items: center;
    padding: ${rem('8px')} ${rem('10px')};
    width: 100%;
  }
  svg {
    margin-left: ${rem('10px')};
  }
`;

const StyledCols = styled.div`
  display: flex;
  margin: 0 ${rem('-16px')};
`;

const StyledCol = styled.div`
  padding: 0 ${rem('16px')} ${rem('25px')};
  width: 50%;
  ${mediaqueries.greaterThan('tablet')`
    flex:initial;
    display:flex;
    align-items: center;
    &:first-child {
        width:70%;
      }
  `};
`;

const StyledButtonGhost = styled(Buttons)`
  display: none;
  ${mediaqueries.greaterThan('tablet')`
    border-color: ${props => props.theme.colors.dark};
    color: ${props => props.theme.colors.dark};
    display:inline-block;
    &:hover {
        border-color: ${props => props.theme.colors.primary};
    }
  `};
`;

const StyledButtonSecondary = styled(Buttons)``;

const StyledButtonsWrapper = styled.div`
  display: block;
  margin: 0 ${rem('-10px')};
  ${mediaqueries.greaterThan('tablet')`
    display: flex;
    justify-content: ${props =>
      props.formPayrroll ? css`flex-end` : css`flex-start`};
  `};
  button {
    font-size: ${props => props.theme.fontSize.small};
    height: auto;
    line-height: ${rem('12px')};
    margin: 0 ${rem('10px')};
    padding: ${rem('9px')} ${rem('20px')};
  }
`;

const StyledPreviousPayrolls = styled.div`
  background-color: #f3f3f3;
  padding: 1.875rem 1.25rem 2.5rem 1.25rem;
  width: 75%;
  position: relative;
  margin: 5% 12%;

  .form-success,
  .form-error {
    display: flex;
    align-items: center;
  }
  .payrroll-loading {
    position: absolute;
    left: ${rem('22px')};
    bottom: ${rem('7px')};
  }
`;

const StyledText = styled.p`
  font-size: ${rem('14px')};
  margin-bottom: ${rem('30px')};
`;

const StyledCellDownload = styled(Cell)`
  width: ${rem('65px')};
  padding-left: 0;
  text-align: center;
  & > svg {
    width: ${rem('18px')};
  }
`;

const StyledPayrrollIncidence = styled.div`
  max-width: ${rem('600px')};
  margin-top: ${rem('37px')};
`;

const StyledPayrrollMsj = styled.div`
  ${props =>
    props.sent &&
    !props.loading &&
    css`
      display: flex;
      justify-content: space-between;
    `}
`;

const StyledTwoLevelBreadcrumb = styled(TwoLevelBreadcrumb)`
  max-width: 1232px;
  margin: 0 ${rem('15px')} ${rem('20px')};
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('-40px')} auto ${rem('15px')} auto;
  `}
`;

const StyledButton = styled(Buttons)`
  font-size: ${rem('14px')};
  height: ${rem('32px')};
  line-height: ${rem('8px')};
  display: block;
  background-color: #191919;
  width: ${rem('170px')};
`;

export {
  StyledMain,
  StyledMenuTabs,
  StyledWrapper,
  StyledBoxContainer,
  StyledLatestPayrolls,
  StyledModal,
  StyledInput,
  StyledAccordionActions,
  StyledAccordionActionsTableInfo,
  StyledLatestPayrollsButton,
  StyledLatestPayrollsItem,
  StyledLatestPayrollsList,
  StyledLatestPayrollsText,
  StyledTitleGivens,
  StyledButtonGhost,
  StyledButtonSecondary,
  StyledButtonsWrapper,
  StyledCol,
  StyledCols,
  StyledDropdownInput,
  StyledLabel,
  StyledPreviousPayrolls,
  StyledTitle,
  StyledText,
  StyledCellDownload,
  StyledPayrrollIncidence,
  StyledPayrrollMsj,
  StyledTwoLevelBreadcrumb,
  StyledButton
};
